
















import { Component, Vue } from "vue-property-decorator";
import FileManager from "@/components/files/FileManager.vue";
import { FolderEntites } from "@/services/folders/types";
import { Getter } from "vuex-class";
import { CurrentUser } from "@/store/authentication/types";
const namespace: string = "authentication";

@Component({
    components: {
        "file-manager": FileManager
    }
})
export default class SystemFiles extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser!: CurrentUser;
    types = [];
    folderEntities = FolderEntites;
}
